import { Link } from "react-router-dom";

const NAV_LINKS = [
  { label: "Calculator", to: "/" },
  { label: "Subjects", to: "/subjects" },
  { label: "Find a Tutor", to: "/tutors/find" },
  { label: "About", to: "/about" },
  { label: "Articles", to: "/articles" },
  { label: "Q&A", to: "/qa" },
];

const LEGAL_LINKS = [
  { label: "Contact Us", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy-policy" },
];

export default function Footer({ isCalculatorPage = false }) {
  return (
    <footer className={`site-footer relative z-20 w-full ${isCalculatorPage ? "bg-[#f9fafb] text-black border-t border-black/[0.07]" : "bg-black text-white border-t border-white/[0.08]"}`}>
      <div className="max-w-6xl mx-auto px-6 py-10 sm:py-12">

        {/* top grid */}
        <div className="grid grid-cols-2 sm:grid-cols-[1fr_auto_auto] gap-x-12 gap-y-8 mb-10">

          {/* brand */}
          <div className="col-span-2 sm:col-span-1 flex flex-col gap-3">
            <Link
              to="/"
              className="footer-brand"
            >
              ibcalculator
            </Link>
            <p className="footer-description">
              Made for IB students, by someone who just was one.
            </p>
          </div>

          {/* navigate */}
          <div className="footer-link-group">
            <p className="footer-label">
              Navigate
            </p>
            {NAV_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="footer-link"
              >
                {l.label}
              </Link>
            ))}
          </div>

          {/* legal */}
          <div className="footer-link-group">
            <p className="footer-label">
              Legal
            </p>
            {LEGAL_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="footer-link"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        {/* bottom bar */}
        <div className={`footer-legal border-t pt-6 flex flex-col sm:flex-row justify-between items-center gap-2 ${isCalculatorPage ? "border-black/[0.08] text-gray-500" : "border-white/10 text-gray-500"}`}>
          <span>© {new Date().getFullYear()} ibcalculator. All rights reserved.</span>
          <span>Independent – not affiliated with the IB Organization.</span>
        </div>

      </div>
    </footer>
  );
}
